var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vx-col w-full" }, [
    _c("div", { staticClass: "image-upload-wrap" }, [
      _c("input", {
        ref: "fileInput",
        staticClass: "file-upload-input",
        attrs: { type: "file" },
        on: { change: _vm.readFile }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "drag-text" }, [
        _c("p", { staticClass: "font-bold mb-3 text-xl" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.desc))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }